<template>
    <div>
      <FormInput label="Chat ID" :value="data.chat_id" hint="group/channel id in number" @update="data.chat_id=$event"></FormInput>
      <FormInput label="Count" :value="data.count" hint="How many top referrals to fetch" @update="data.count=$event"></FormInput>
      <p>Magic variable 'leaderboard' contains leaderboard result.</p>
    </div>
</template>
  
  
  <script>
import FormInput from '@/components/tasks/fields/FormInput.vue'
  
  export default {
    name: 'LeaderBoard',
    components:{
        FormInput
    },
    props: {
      data: Object,
      actions: Object
    },
    methods:{
  
    },
  
  
  }
  </script>
  